import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { StorageService } from "../storage/storage.service";

@Injectable({
  providedIn: "root",
})
export class TeamsService {
  private API_URL = environment.API_URL;

  constructor(
    private http: HttpClient,
    private storageService: StorageService
  ) {}

  private getToken() {
    let data = this.storageService.get("user");
    const headers = {
      Authorization: `Bearer ${data?.token}`,
    };
    return headers;
  }

  createTeams(payload: any) {
    const headers = this.getToken();

    return new Promise((resolve, reject) => {
      this.http
        .post(`${this.API_URL}/api-teams`, payload, { headers })
        .subscribe({
          next: (res) => resolve(res),
          error: (err) => reject(err),
        });
    });
  }

  getAllTeams() {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.API_URL}/api-all-teams`).subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err),
      });
    });
  }

  getTeam(id: number) {
    return new Promise((resolve, reject) => {
      this.http.get(`${this.API_URL}/api-teamDetails/${id}`).subscribe({
        next: (res) => resolve(res),
        error: (err) => reject(err),
      });
    });
  }
}
